import { render } from "./BoleteriaReport.vue?vue&type=template&id=160f3fe6&scoped=true"
import script from "./BoleteriaReport.vue?vue&type=script&lang=js"
export * from "./BoleteriaReport.vue?vue&type=script&lang=js"

import "./BoleteriaReport.vue?vue&type=style&index=0&id=160f3fe6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-160f3fe6"]])

export default __exports__